export enum LifeCycle {
  CREATE = 'create',
  UPDATE = 'update',
}
